/** @format */

import React, { useCallback } from 'react';
import { ButtonWrapper, SpinWrapper, ImgWrapper } from './styles';
import loading_svg from '../../../../images/img/loading.svg';

export const types = {
	primary: 'primary',
	secondary: 'secondary',
	supportBuy: 'supportBuy',
	supportThrough: 'supportThrough',
	supportOverlayLight: 'supportOverlayLight',
	supportOverlayDark: 'supportOverlayDark'
};

export const sizes = {
	small: 'small',
	regular: 'regular'
};

const colors = {
	primary: {
		background: 'linear-gradient(180deg, #FFF952 0%, #FFE500 100%)',
		color: '#3D392C',
		hover: '#FFF952',
		active: '#FFF129'
	},
	secondary: {
		background: '#D6D6C9',
		color: '#3D392C',
		hover: '#E3E3D5',
		active: '#D6D6C9'
	},
	supportBuy: {
		background: '#FF6666',
		color: 'white',
		hover: '#FF938F',
		active: '#FF6666'
	},
	supportThrough: {
		background: 'rgba(255, 255, 255, 0.8)',
		color: '#3D392C',
		hover: 'rgba(255, 255, 255, 1)',
		active: 'rgba(255, 255, 255, 0.8)'
	},
	supportOverlayLight: {
		background: 'rgba(255, 255, 255, 0.4)',
		border: '1px solid rgba(255, 255, 255, 0.4)',
		color: 'white',
		hover: 'rgba(255, 255, 255, 0.5)',
		active: 'rgba(255, 255, 255, 0.8)'
	},
	supportOverlayDark: {
		background: 'rgba(61, 57, 44, 0.4)',
		border: '1px solid rgba(61, 57, 44, 0.4)',
		color: '#3D392C',
		hover: 'rgba(61, 57, 44, 0.5)'
	},
	disabled: {
		border: '0',
		background: 'rgba(61, 57, 44, 0.1)',
		color: 'rgba(61, 57, 44, 0.4)'
	}
};

const sizeType = {
	mini: '2px 8px',
	small: '4px 16px',
	regular: '7px 23px'
};

const Button = ({
	loading = false,
	disabled = false,
	children,
	onClick,
	img,
	color = types.primary,
	size = sizes.regular,
	fontSize = '14'
}) => {
	const buttonStyle = loading || disabled ? colors['disabled'] : colors[color];
	const sizeStyle = sizeType[size];

	const handleClick = useCallback(() => {
		if (!disabled && !loading && onClick) {
			onClick();
		}
	}, [onClick, disabled, loading]);

	return (
		<ButtonWrapper
			onClick={handleClick}
			background={buttonStyle.background}
			hover={buttonStyle.hover}
			color={buttonStyle.color}
			border={buttonStyle.border}
			active={buttonStyle.active}
			size={sizeStyle}
			fontSize={fontSize}>
			{loading && (
				<SpinWrapper>
					<img className="loading" src={loading_svg} />
				</SpinWrapper>
			)}
			{!loading && img && (
				<ImgWrapper>
					<img src={img} />
				</ImgWrapper>
			)}
			{!loading && children}
		</ButtonWrapper>
	);
};

export default React.memo(Button);
